import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const BloodOxygenPage = lazy(() => import("./BloodOxygenPage.tsx"));

const BloodOxygenPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <BloodOxygenPage />
    </Suspense>
  );
};

export default BloodOxygenPageLazy;
